import { createFileRoute, redirect } from "@tanstack/react-router";

import Login from "areas/auth/pages/Login";


export const Route = createFileRoute("/auth/")({
	component: () => <Login />,
	beforeLoad: ({ context }) => {
		if (context.auth0?.isAuthenticated) throw redirect({ to: "/" });
	},
	staticData: {
		lite: true
	}
});